module.exports = __webpack_public_path__ + "static/generation-medemer-book-jacket-eed295f5e0135150e16f15af65b77adf.jpeg";